import { html } from '../html.js';
import { DEFAULT_PRINT_OPTIONS } from '../print-options.js';
import { t } from '../strings.js';
import { docDate, field, fields, footer, header, ltr } from './parts.js';
import { notesBlock, party, pricedLineTable, statusBadge, statusLabel, totalsBlock, } from './record-parts.js';
/**
 * PUR-01's purchase order as a printed document — the paper that goes TO the
 * supplier, and the one wave 2's "Send to supplier" attaches to its email.
 *
 * Its own two facts: the EXPECTED DATE the goods are wanted by, and whether
 * — and when — the order was SENT. A purchase order's status is the one that
 * matters to the other party: a supplier holding a "draft" has nothing to
 * ship against, so the status is a header field on every copy and a stamp on
 * the draft.
 */
export function purchaseOrderHtml(data, locale, company, generatedAt, generatedBy, print = DEFAULT_PRINT_OPTIONS) {
    return html `
    ${header(company, t('purchaseOrderTitle', locale), statusBadge(data.status, locale))}
    ${fields([
        field(t('purchaseOrderNo', locale), ltr(data.code)),
        field(t('invoiceDate', locale), docDate(data.orderDate)),
        field(t('supplierCode', locale), ltr(data.partnerCode)),
        field(t('status', locale), statusLabel(data.status, locale)),
        ...(data.expectedDate === null ? [] : [field(t('expectedDate', locale), docDate(data.expectedDate))]),
        ...(data.sentAt === null ? [] : [field(t('sentOn', locale), docDate(data.sentAt))]),
    ])}
    ${party(t('supplier', locale), data.partnerName)}
    ${pricedLineTable(data.lines, data.currency, locale, print)}
    ${totalsBlock(data, locale, print)}
    ${notesBlock(t('notes', locale), data.notes)}
    ${footer(locale, generatedAt, company.name, generatedBy)}
  `;
}
//# sourceMappingURL=purchase-order.js.map